<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__accessmanagementlog}">
      <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
       <el-form-item label="">
          <wPickers v-model="dateValue" @input="getTimes"></wPickers>
        </el-form-item>
        <!-- <el-form-item>
          <wList
            v-model="dataForm.company"
            dataUrl="/sys/channels/list"
            placeholder="平台"
          ></wList>
        </el-form-item> -->
        
        <el-form-item>
          <renSelect
            v-model="dataForm.product"
            dictType="loan_type"
            originPage="put"
            placeholder="产品"
          ></renSelect>
        </el-form-item>

        <el-form-item>
          <el-button @click="getDataList()">{{ $t("query") }}</el-button>
        </el-form-item>
        <!-- <el-form-item>
            <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button v-if="$hasPermission('sys:accessmanagementlog:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button v-if="$hasPermission('sys:accessmanagementlog:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
          </el-form-item> -->
      </el-form>
      <!-- v-if="$hasPermission('sys:advertoauth:delete')" -->
      <div class="balance" v-if="money != null">账户余额：{{money}}元</div>
      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        @selection-change="dataListSelectionChangeHandle"
        style="width: 100%"
        @sort-change="dataListSortChangeHandle($event,false)"
      >
      <el-table-column
          prop="companyName"
          label="公司"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="storeReportsDates"
          label="日期"
          header-align="center"
          align="center"
          sortable="custom"
        >
        <template slot-scope="scope">
          <div>
            {{scope.row.storeReportsDates.split(' ')[0]}}
          </div>
        </template>
      </el-table-column>
        <el-table-column
          prop="productName"
          label="产品"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="city"
          label="城市"
          header-align="center"
          align="center"
          sortable="custom"
        ></el-table-column>
        <el-table-column
        v-if="$hasPermission('put:shop:demand')"
          prop="demandLeads"
          label="需求线索数量"
          header-align="center"
          align="center"
          sortable="custom"
        ></el-table-column>
        <el-table-column
        v-if="$hasPermission('put:shop:thread')"
          prop="lockThread"
          label="锁定线索数量"
          header-align="center"
          align="center"
          sortable="custom"
        ></el-table-column>
        <el-table-column
        v-if="$hasPermission('put:shop:practical')"
          prop="actualClues"
          label="实际数量"
          header-align="center"
          align="center"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="pricing"
          label="定价"
          header-align="center"
          align="center"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="deplete"
          label="营收"
          header-align="center"
          align="center"
          sortable="custom"
        ></el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
    </div>
  </el-card>
</template>
  
  <script>
import mixinViewModule from "@/mixins/view-module";

export default {
  mixins: [mixinViewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/sys/storereports/page",
        getDataListIsPage: true,
        exportURL: "/sys/storereports/export",
        deleteURL: "/sys/storereports",
        deleteIsBatch: true,
      },
      dateValue: "",
      userList: [],
      money: null,
      dataForm: {
        id: "",
        product: "",
        startDate: "",
        endDate: "",
     
      },
    };
  },
  mounted() {
    // this.getSelectList();
    this.getCompany()
  },
  methods: {
    getTimes() {
      if (this.dateValue != null) {
        this.dataForm.startDate = this.dateValue[0];
        this.dataForm.endDate = this.dateValue[1];
      } else {
        this.dataForm.startDate = "";
        this.dataForm.endDate = "";
      }
    },
    getCompany() {
      this.$http
        .post("/sys/storereports/deliveryInformation")
        .then(({ data: res }) => {
          if(res.code != 0){
            this.$message.error(res.msg)
          }
          console.log(res.data.accountBalance == null)

          this.money = res.data.inactiveBalance
            // ? res.data.accountBalance
            // : 0;
        });
    },
    getSelectList() {
      this.$http("/sys/user/page", { params: { page: 1, limit: 1000 } }).then(
        ({ data: res }) => {
          if (res.code != 0) {
            this.$message.error(res.msg);
          }
          this.userList = res.data.list.map((item) => {
            return {
              value: item.id,
              label: item.realName,
            };
          });
        }
      );
    },
  },
  components: {},
};
</script>
<style>
.balance{
  margin-bottom: 10px;
  color: red;
}
</style>
  
  